










import Vue from 'vue';

export default Vue.extend({
  name: 'GLoading',
  computed: {
    loading() {
      return this.$stores.loading.isLoading;
    },
  },
  watch: {
    loading(loading: boolean) {
      if (loading) {
        // モーダルが開いた時にスクロールバーを非表示にする
        document.documentElement.className = 'loading';
        document.body.className = 'loading';
      } else {
        // モーダルが開いた時にスクロールバーの非表示を解除する
        document.documentElement.className = '';
        document.body.className = '';
      }
    },
  },
});
